export default {
    name: 'ErrorCodes',
    data() {
        return {
            Keyword: '',
        };
    },
    mounted() {
        window.model = this;
        this.load();
    },
    methods: {
        async load() {
            var result = await this.$api.getErrorCodes();
            var cols = [
                {
                    title: "故障代碼",
                    data: "ErrorCode"
                },
                {
                    title: "代碼說明",
                    data: "Description"
                }
            ];
            this.createDataTable('#tableErrorCodes', cols, result, { bSort: false });
            setTimeout(() => {
                $('div.dataTables_wrapper div.dataTables_filter').hide();
            });
        },
        search(){
            $('div.dataTables_wrapper div.dataTables_filter input').val(this.Keyword);
            $('div.dataTables_wrapper div.dataTables_filter input').trigger('paste');
        }
    }
}